import { lazy } from 'react';

// project-imports
// import GuestGuard from 'utils/route-guard/GuestGuard';
// import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages_vms/auth_vms/login')));
const VisitorType = Loadable(lazy(() => import('pages_vms/SubmissionForms/VisitorType')));
const ThankYou = Loadable(lazy(() => import('pages_vms/SubmissionForms/Thankyou')));
const AuthCodeVerification = Loadable(lazy(() => import('pages_vms/auth_vms/code-verification')));
// const MainForm = Loadable(lazy(() => import('pages_vms/SubmissionForms/DirectVisitor/MainForm')));
const Unauthorized = Loadable(lazy(() => import('pages_vms/Unauthorized')));
const ErrorPage = Loadable(lazy(() => import('pages_vms/SubmissionForms/Error')));
const KioskForm = Loadable(lazy(() => import('pages_vms/SubmissionForms/Kiosk/KioskForm')));
const FormEntry = Loadable(lazy(() => import('pages_vms/SubmissionForms/FormEntry')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes_VMS = {
  path: '/vms/',
  children: [
    {
      path: 'login/',
      element: <AuthLogin />
    },
    {
      path: 'verification/',
      element: <AuthCodeVerification />
    },
    {
      path: 'response/',
      element: <ThankYou />
    },
    {
      path: 'URL/:string',
      element: <VisitorType />
    },
    {
      path: 'kiosk-form/:string',
      element: <KioskForm />
    },
    {
      path: 'errorPage/',
      element: <ErrorPage />
    },
    {
      path: 'unauthorized/',
      element: <Unauthorized />
    }
  ]
};

// Walk-in/Review are the two links texted directly to visitors, so they live at the site root
// instead of under /vms/, sharing one common path with the form type as a query key
// (e.g. https://vms.sgops.in/f?w=<token> for Walk-in, .../f?r=<token> for Review) — FormEntry.js
// reads whichever key is present and renders the matching form. Every other visitor-facing route
// above stays under /vms/ since nothing external links to those.
export const VisitorFormRoutes = [
  {
    path: 'f',
    element: <FormEntry />
  }
];

export default LoginRoutes_VMS;
